(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer-testimonial"]) return;
  try {
    
(function () {
  function initCartSlider(root) {
    // The cart drawer's empty-state markup is cloned into place via
    // innerHTML (see the sync script in theme.liquid), which copies HTML
    // attributes verbatim but not JS state — a dataset/attribute flag here
    // would get baked into that copy and wrongly mark the freshly-cloned,
    // never-actually-initialized slider as "already done", permanently
    // breaking its autoplay and dot navigation. A plain JS property lives
    // only on this exact node, so a clone never inherits it.
    if (root._cartSliderInit) return;

    var slides = Array.prototype.slice.call(root.querySelectorAll('.cart-slider__slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.cart-slider__dot'));
    if (!slides.length) return;

    root._cartSliderInit = true;

    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(root.getAttribute('data-speed'), 10) || 5000;
    var current = 0;
    var timer = null;

    function goTo(index) {
      if (index === current) return;
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = index;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function next() {
      goTo((current + 1) % slides.length);
    }

    function start() {
      if (!autoplay || slides.length < 2) return;
      stop();
      timer = setInterval(next, speed);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        start();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    start();
  }

  function initAll() {
    document.querySelectorAll('.cart-slider').forEach(initCartSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('initCartFunctions', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psf-science-interactive"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('psf-evidence')) {
    customElements.define('psf-evidence', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.tabs = Array.from(this.querySelectorAll('[data-psfs-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-psfs-panel]'));
        this.nav = this.querySelector('[data-psfs-nav]');
        if (!this.tabs.length || !this.nav) return;
        this.nav.setAttribute('role', 'tablist');
        this.media = window.matchMedia('(max-width: 700px)');
        this.setOrientation = () => this.nav.setAttribute('aria-orientation', this.media.matches ? 'horizontal' : 'vertical');
        this.setOrientation();
        this.media.addEventListener('change', this.setOrientation, { signal });
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', this.panels[index].id);
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].setAttribute('aria-labelledby', tab.id);
          this.panels[index].setAttribute('tabindex', '0');
          tab.addEventListener('click', (event) => {
            event.preventDefault();
            this.activate(index);
          }, { signal });
          tab.addEventListener('keydown', (event) => {
            const previous = this.media.matches ? 'ArrowLeft' : 'ArrowUp';
            const next = this.media.matches ? 'ArrowRight' : 'ArrowDown';
            let target;
            if (event.key === previous) target = (index - 1 + this.tabs.length) % this.tabs.length;
            if (event.key === next) target = (index + 1) % this.tabs.length;
            if (event.key === 'Home') target = 0;
            if (event.key === 'End') target = this.tabs.length - 1;
            if (event.key === ' ') target = index;
            if (target === undefined) return;
            event.preventDefault();
            this.activate(target);
            this.tabs[target].focus({ preventScroll: true });
          }, { signal });
        });
        document.addEventListener('shopify:block:select', (event) => {
          const index = this.tabs.findIndex((tab) => tab.dataset.blockId === event.detail?.blockId);
          if (index !== -1) this.activate(index);
        }, { signal });
        this.setAttribute('data-enhanced', '');
        const linked = this.panels.findIndex((panel) => '#' + panel.id === window.location.hash);
        this.activate(linked === -1 ? 0 : linked, false);
      }
      activate(index, reveal = true) {
        this.tabs.forEach((tab, position) => {
          const active = position === index;
          tab.setAttribute('aria-selected', String(active));
          tab.setAttribute('tabindex', active ? '0' : '-1');
          this.panels[position].hidden = !active;
        });
        const count = this.querySelector('[data-psfs-count]');
        if (count) count.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(this.tabs.length).padStart(2, '0');
        if (reveal && this.media.matches) {
          const tab = this.tabs[index];
          const edge = tab.getBoundingClientRect();
          const viewport = this.nav.getBoundingClientRect();
          if (edge.left < viewport.left) this.nav.scrollLeft += edge.left - viewport.left - 5;
          else if (edge.right > viewport.right) this.nav.scrollLeft += edge.right - viewport.right + 5;
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
